/*  ========================================================================
    # Sections - Application Process
    ========================================================================  */

import React, { useState, createElement } from 'react';
import PropTypes from 'prop-types';
import useTranslation from '@/react/hooks/useTranslation';
import useBreakpoints from '@/react/hooks/useBreakpoints';

const Solutions = ({ link, headline, entries, entriesHeadingLevel }) => {
  const __ = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const { lg } = useBreakpoints();

  const handleEntryClick = (e, index) => {
    e.preventDefault();
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <div className='container'>
        <div className='s-solutions__wrapper'>
          <div className='s-solutions__content'>
            <div className='wysiwyg-block' dangerouslySetInnerHTML={{ __html: headline }} />
            {link && (
              <a href={link.url} title={link.title} className='s-solutions__link u-link-with-svg u-link-with-svg--arrow'>
                {link.title}
              </a>
            )}
          </div>
          <div className='s-solutions__grid'>
            {entries && entries.map((entry, index) => (
              <a href={entry.link.url} title={entry.link.title} className={`s-solutions__entry ${activeIndex === index ? 'open' : ''}`} key={index}>
                <figure className='s-solutions__entry-image'>
                  <picture>
                    <img src={entry.background_image.sizes.large} alt={entry.background_image.alt || ''} loading='lazy' />
                  </picture>
                </figure>
                <div className='s-solutions__entry-info'>
                  <button className='s-solutions__entry-title' type='button' disabled={lg} onClick={e => handleEntryClick(e, index)}>
                    {createElement(entriesHeadingLevel, { className: 's-solutions__entry-heading' }, entry.title)}
                    <span aria-hidden></span>
                  </button>
                  <div className='s-solutions__entry-content'>
                    <div className='wysiwyg-block' dangerouslySetInnerHTML={{ __html: entry.content }} />
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

Solutions.propTypes = {
  link: PropTypes.array,
  headline: PropTypes.string,
  entries: PropTypes.array,
  entriesHeadingLevel: PropTypes.string
};

export default Solutions;
